import { combineReducers } from 'redux'

import { Resource }            from '../../api'
import { api, uploadResource } from '../../client'
import { bind, unique }        from '../../utils'
import createAction            from '../redux-utils/create-action'
import { Reducer }             from '../types'
import { createRequest }       from './communication.duck'

const RESOURCES = 'resources'

export const RESOURCES_GET_BY_PROCESS_ID_SUCCESS = `[${RESOURCES}] GET_BY_PROCESS_ID_SUCCESS`
export const RESOURCES_UPLOAD_SUCCESS = `[${RESOURCES}] UPLOAD_SUCCESS`

interface ExtendedResource extends Resource {
  programId: number
}

interface ByIdState {
  [ id: number ]: ExtendedResource
}

const byId: Reducer<ByIdState> = (
  state = {},
  action,
) => {
  const { type, payload } = action

  switch (type) {
    case RESOURCES_GET_BY_PROCESS_ID_SUCCESS: {
      const { processId } = payload

      return {
        ...state,
        ...payload.resources.reduce(
          (reduction, resource) => ({
            ...reduction,
            [ resource.id ]: {
              ...resource,
              processId,
            },
          }),
          {}
        ),
      }
    }

    case RESOURCES_UPLOAD_SUCCESS: {
      const { resource, processId } = payload

      return {
        ...state,
        [ resource.id ]: {
          ...resource,
          processId,
        }
      }
    }

    default:
      return state
  }
}

type IdsState = Resource []

const ids: Reducer<IdsState> = (
  state = [],
  action,
) => {
  const { type, payload } = action

  switch (type) {
    case RESOURCES_GET_BY_PROCESS_ID_SUCCESS:
      return unique([
        ...state,
        ...payload.resources.map(resource => resource.id),
      ])

    case RESOURCES_UPLOAD_SUCCESS:
      return unique([
        ...state,
        payload.resource.id,
      ])

    default:
      return state
  }
}

export interface ResourcesState {
  byId: ByIdState
  ids: IdsState
}

export default combineReducers({
  byId,
  ids,
})

const handleResourcesByProcessIdGetSucces = ({ results }, processId) =>
  createAction(
    RESOURCES_GET_BY_PROCESS_ID_SUCCESS,
    {
      processId,
      resources: results,
    },
  )

const handleResourceCreated = (resource, processId) =>
  createAction(
    RESOURCES_UPLOAD_SUCCESS,
    { resource, processId },
    {
      toast: {
        message: 'fileUploaded',
      },
    },
  )

export const resourcesByProcessIdRequest = createRequest({
  namespace:      `${RESOURCES}-by-process-id-get`,
  request:        bind(api)(api.getProcessResources),
  successHandler: handleResourcesByProcessIdGetSucces,
})

export const resourcesCreateRequest = createRequest({
  namespace:      `${RESOURCES}-upload`,
  request:        uploadResource,
  successHandler: handleResourceCreated,
})

const selectAllResources = ({ resources: { ids, byId } }) =>
  ids.map(id => byId[ id ]).reverse()

export const selectResourcesByProcessId =
  processId =>
    state =>
      selectAllResources(state)
        .filter(resource => resource.processId === processId)



// WEBPACK FOOTER //
// ./src/redux/ducks/resources.duck.ts